export default function EntityFieldEdit({ childrenFunc, required = false, disabled = false, ...field }) {
    return childrenFunc(true, field, { required, disabled });
}
